<template>
  <div class="_component-serve">
    <div class="qr-wrap img-wrap">
      <img src="//hsylc.oss-cn-hangzhou.aliyuncs.com/2026/qr/qr-1.png" alt="" />
    </div>
    <p class="text3 color-gray-2 mt-10 t-ct">打开微信扫一扫</p>
    <p class="text1 bold text-1 t-ct color-black-1">在线客服</p>
    <div class="close-wrap" @click="$emit('close')"></div>
  </div>
</template>
<script>
export default {
  name: 'Serve'
};
</script>
<style lang="less" scoped src="./index.less"></style>
